import React from 'react';
import Img from "../../images/services/ls/Lean.png";
import {Container, Row, Col} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";

function Buildpurpose(props) {
    return (
        <div className="services_orange_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto text-center order-2 order-md-1">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="services_title my-auto order-1 order-md-2">
                        <h2>Create The Best Lean Startup Business Plan</h2>
                        <p>A lean startup method is different from what is prevalent in the market. It requires patience and perseverance to build a startup, and the lean startup approach streamlines that. In this approach, no matter how new we are to a domain, we learn, build, implement and unlearn to develop a masterpiece.</p>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Buildpurpose;